import React from 'react';

const Main = ({ children, className }, ref) => (
    <div
        style={{ overflow: 'scroll', height: 'calc(100vh - 100px)' }}
        className={`max-w-8xl mx-auto p-4 space-y-4 ${className}`}
        ref={ref}
    >
        {children}
    </div>
);

export default React.forwardRef(Main);
